import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';
import {
  CalendarApiQueryParams,
  CalendarResultParams,
  CalendarDownloadApiParams,
} from '../../../typings/api';

export const getUpcoming = async ({
  discipline,
  raceCategory,
  raceType,
  raceClass,
  country,
  year,
  seasonId,
}: CalendarApiQueryParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/calendar/upcoming`, {
    params: {
      discipline,
      raceCategory,
      raceType,
      raceClass,
      country,
      year,
      seasonId,
    },
  });

  return data;
};

export const getPast = async ({
  discipline,
  raceCategory,
  raceType,
  raceClass,
  country,
  seasonId,
  year,
}: CalendarApiQueryParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/calendar/past`, {
    params: {
      discipline,
      raceCategory,
      raceType,
      raceClass,
      country,
      seasonId,
      year,
    },
  });

  return data;
};

export const getResult = async ({
  eventCode,
  raceType,
  disciplineCode,
  raceName,
}: CalendarResultParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/calendar/results/${eventCode}`, {
    params: {
      discipline: disciplineCode,
      raceType,
      raceName,
    },
  });

  return data;
};

export const getCwc = async (discipline: string) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/calendar/cwc`, {
    params: { discipline: discipline || '' },
  });

  return data;
};

export const downloadCalendar = async (
  url: string,
  bearerToken: string,
  params: CalendarDownloadApiParams,
) => {
  const response: AxiosResponse = await Axios.post(url, params, {
    responseType: 'blob',
    headers: { Authorization: `Bearer ${bearerToken}` },
  });

  return response;
};
